import {UddannelseTypeEnum} from "../../../core/sharedmodels/stilling/uddannelseTypeEnum";
import {Localizer} from "../../../infrastructure/localization/localizer";

export class DashboardColors {

    public static readonly KbuColor = "#97C9F9";
    public static readonly IntroduktionColor = "#428BEF";
    public static readonly HoveduddannelseColor = "#2348AA";
    public static readonly SpecialeColors = ["#75CD7D", "#FCC75E", "#5EAFE9", "#2F8337", "#C6F1D7", "#CD9832", "#FFEECC", "#0088CC", "#DBF0FA", "#4D3BC5", "#CCE852", "#23B5B5"];

    public static readonly SletIkkeColor = "lightgray";
    public static readonly PlanlagtColor = "#6bb0eb";
    public static readonly KlarmeldtOgOverEnMaanedColor = "#f7c655";
    public static readonly AfholdtOgUnderEnMaanedColor = "#80cd7a";
    public static readonly OverskredetOgOverSeksMaanederColor = "#b9413f";
    public static readonly OverTreMaanederColor = "#F9736D";

    public static readonly KompetenceBarChartColor = "#2F54AD";

    public static readonly JusterendeVejledersamtaleBarChartColor = "#2F54AD";
    public static readonly UddannelsesplanerBarChartColor = "#2F54AD";

    public static readonly ForloebProgressColor = "#C6F1D7";

    public static RandomColorUtility(length: number) {
        return Math.floor(Math.random() * length);
    }

    public static RandomHex() {
        const hex = [1, 2, 3, 4, 5, 6, 7, 8, 9, "A", "B", "C", "D", "E", "F"];
        let hexColor = "#";
        for (let i = 0; i < 6; i++) {
            hexColor += hex[this.RandomColorUtility(hex.length)];
        }
        return hexColor;
    }

    public static GetUddannelsestrinFillColor(uddannelsestype: number): string {
        switch (uddannelsestype) {
            case UddannelseTypeEnum.KBU:
                return DashboardColors.KbuColor;
            case UddannelseTypeEnum.Introduktion:
                return DashboardColors.IntroduktionColor;
            case UddannelseTypeEnum.Hoveduddannelse:
                return DashboardColors.HoveduddannelseColor;
            default:
                return DashboardColors.RandomHex();
        }
    }

    public static GetSpecialeColor(index: number, specialenavn: string) {
        if (specialenavn?.toLowerCase() === Localizer.global_kliniskBasisuddannelse().toLowerCase())
            return DashboardColors.KbuColor;

        return index >= DashboardColors.SpecialeColors.length
            ? DashboardColors.RandomHex()
            : DashboardColors.SpecialeColors[index];
    }

    public static GetVejledningColor(chartName: string) {
        switch (chartName) {
            case Localizer.global_endnuIkkePlanlagt():
            case Localizer.global_endnuIkkeOprettet():
            case Localizer.dashboard_sletIkke():
                return DashboardColors.SletIkkeColor;
            case Localizer.global_planlagt():
            case Localizer.global_oprettet():
                return DashboardColors.PlanlagtColor;
            case Localizer.global_klarmeldt():
            case Localizer.dashboard_overEnMaaned():
                return DashboardColors.KlarmeldtOgOverEnMaanedColor;
            case Localizer.global_afholdt():
            case Localizer.global_godkendt():
            case Localizer.dashboard_underEnMaaned():
                return DashboardColors.AfholdtOgUnderEnMaanedColor;
            case Localizer.global_overskredetFrist():
            case Localizer.dashboard_overSeksMaaneder():
                return DashboardColors.OverskredetOgOverSeksMaanederColor;
            case Localizer.dashboard_overTreMaaneder():
                return DashboardColors.OverTreMaanederColor;
            default:
                return DashboardColors.RandomHex();
        }
    }
    public static GetKompetenceAktivitetColor(chartName: string) {
        switch (chartName) {
            case Localizer.dashboard_ingenAktivitet():
                return DashboardColors.SletIkkeColor;
            case Localizer.dashboard_underEnUge():
                return DashboardColors.AfholdtOgUnderEnMaanedColor;
            case Localizer.dashboard_overEnUge():
                return DashboardColors.KlarmeldtOgOverEnMaanedColor;
            case Localizer.dashboard_overEnMaaned():
                return DashboardColors.OverTreMaanederColor;
            case Localizer.dashboard_overTreMaaneder():
                return DashboardColors.OverskredetOgOverSeksMaanederColor;
            default:
                return DashboardColors.RandomHex();
        }
    }
}
